var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rental-price" },
    [
      _vm.rentalVideo
        ? _c("md-switch", {
            model: {
              value: _vm.inputAvailable,
              callback: function($$v) {
                _vm.inputAvailable = $$v
              },
              expression: "inputAvailable"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-input-container",
        [
          _c("label", { attrs: { for: "price" } }, [_vm._v("Rental price")]),
          _vm._v(" "),
          _c(
            "md-select",
            {
              attrs: { disabled: !_vm.inputAvailable },
              on: { input: _vm.emitSelection },
              model: {
                value: _vm.selectedOption,
                callback: function($$v) {
                  _vm.selectedOption = $$v
                },
                expression: "selectedOption"
              }
            },
            _vm._l(_vm.prices, function(option) {
              return _c(
                "md-option",
                { key: option, attrs: { value: option } },
                [
                  _vm._v(
                    "\n                $ " +
                      _vm._s(_vm.formatPrice(option)) +
                      "\n            "
                  )
                ]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1483844c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1483844c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/RentalPricingForm.vue
// module id = 790
// module chunks = 0